import { types, getParent, flow, applySnapshot } from 'mobx-state-tree';

export const SubscriptionProps = types.model('SubscriptionProps', {
    PUKcode: types.string,
    SIMcardNumber: types.string,   
    description: types.string,
    extra1: types.optional(types.string, ''),
    extra2: types.optional(types.string, ''), 
})
    .views(self => ({
        get loggedinUser() {
            return getParent(self);
        },                
    }))
    .actions(self => ({
        updateMsgAmount(json: string) {
            applySnapshot(self, JSON.parse(json));
        },

        setTest() {
            self.PUKcode = '11122233';
            self.SIMcardNumber = '1112223334445556667';
            self.description = 'Med Tellit to Go kan du ringa inom landet, skicka SMS och MMS och surfa.';
            self.extra1 = 'Tellit to Go finns med flera olika surfpaket - 1GB, 5GB, 10GB, 30GB eller 100GB surf.';
            self.extra2 = 'Samtal till utlandet samt betalsamtal ingår inte i abonnemanget.';                       
        },
        
    }));

export default SubscriptionProps;


// WEBPACK FOOTER //
// ./src/models/SubscriptionProps.ts